import produce from 'immer';
import { ReducerAction } from 'store/modules/types';

// TYPES
import { Types, UploadArquivo } from './types';

export const INITIAL_STATE: UploadArquivo = {
	status: 0,
	data: null,
	detailsFile: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): UploadArquivo {
	return produce(state, draft => {
		switch (action.type) {
			case Types.UPLOAD_ARQUIVO_REQUEST: {
				draft.status = 100;
				draft.data = INITIAL_STATE.data;
				draft.detailsFile = INITIAL_STATE.detailsFile;
				break;
			}

			case Types.UPLOAD_ARQUIVO_SUCCESS: {
				draft.data = action.payload.response;
				draft.detailsFile = action.payload.request;
				draft.status = 200;
				break;
			}

			case Types.UPLOAD_ARQUIVO_FAILURE: {
				draft.data = INITIAL_STATE.data;
				draft.detailsFile = INITIAL_STATE.detailsFile;
				draft.status = 400;
				break;
			}
			case Types.UPLOAD_ARQUIVO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				draft.detailsFile = INITIAL_STATE.detailsFile;
				break;
			}

			default:
		}
	});
}
